import { z } from "zod";

import {
  SMS_PERFORMANCE_SORT_KEYS,
  SMS_STATUS,
  SMS_TREND_METRIC_KEYS,
} from "@/constants/sms-analytics";

export const smsTrendMetricSchema = z.enum(SMS_TREND_METRIC_KEYS);

const smsPerformanceSortKeySchema = z.enum(SMS_PERFORMANCE_SORT_KEYS);

export const smsPerformanceSortSchema = z.union([
  smsPerformanceSortKeySchema,
  z.templateLiteral(["-", smsPerformanceSortKeySchema]),
]);

const rateSchema = z.number().nullable();

export const smsCountsSchema = z.object({
  sent: z.number(),
  failed: z.number(),
  linkSms: z.number(),
  clickedSms: z.number(),
  totalClicks: z.number(),
  failedRate: rateSchema,
  clickRate: rateSchema,
});

export const smsStatusSchema = z.object({
  subscribed: z.number(),
  patientsWithPhone: z.number(),
  subscribedRate: rateSchema,
  failed: z.number(),
  attempts: z.number(),
  failedRate: rateSchema,
});

export const smsStatusResponseSchema = z.object({
  data: smsStatusSchema,
});

export const smsTrendPointSchema = smsCountsSchema.extend({
  periodStart: z.string(),
});

export const smsTrendsResponseSchema = z.object({
  data: z.array(smsTrendPointSchema),
  totals: smsCountsSchema,
  previousTotals: smsCountsSchema,
});

export const smsTypePerformanceSchema = smsCountsSchema.extend({
  smsType: z.string(),
  linkExpected: z.boolean(),
});

export const smsPerformanceResponseSchema = z.object({
  data: z.array(smsTypePerformanceSchema),
  totals: smsCountsSchema,
});

export const profileSmsSchema = z.object({
  id: z.number(),
  smsType: z.string(),
  linkExpected: z.boolean(),
  createdAt: z.string(),
  sentAt: z.string().nullable(),
  status: z.nativeEnum(SMS_STATUS),
  hasLink: z.boolean(),
  clicks: z.number(),
  lastClickedAt: z.string().nullable(),
});

export const profileSmsResponseSchema = z.object({
  data: z.array(profileSmsSchema),
  totals: smsCountsSchema,
});
